import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('jette_lang') || 'da';
  });

  useEffect(() => {
    localStorage.setItem('jette_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggleLanguage = () => {
    setLang((prev) => (prev === 'da' ? 'en' : 'da'));
  };

  // Helper function to resolve CMS localized field objects
  const getLoc = (field) => {
    if (!field) return '';
    if (typeof field === 'string') return field;
    if (typeof field === 'object') {
      return field[lang] || field.da || field.en || Object.values(field)[0] || '';
    }
    return '';
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLanguage, getLoc }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
